<template>
  <span
    v-if="brand.wordmark"
    class="tw:inline-flex tw:items-baseline tw:leading-none tw:whitespace-nowrap"
    :class="tone === 'light' ? 'tw:text-white' : 'tw:text-primary'"
    :style="{ fontSize: `${size}px`, fontFamily: 'var(--font-brand)' }"
    role="img"
    :aria-label="brand.name"
    v-bind="$attrs">
    <span class="tw:font-light">{{ brand.wordmark.light }}</span>
    <span class="tw:ml-[0.3em] tw:font-extrabold tw:tracking-[0.02em]">{{ brand.wordmark.bold }}</span>
    <span
      class="tw:ml-[0.3em] tw:inline-block tw:size-[0.32em] tw:self-center tw:rounded-full tw:bg-brand-accent"></span>
  </span>
  <slot v-else />
</template>

<script setup lang="ts">
import { brand } from '@/config/brands';

/** the brand's text wordmark, or the slot content (the logo image) for a brand without one */
defineOptions({ inheritAttrs: false });

interface Props {
  tone?: 'dark' | 'light';
  size?: number;
}

withDefaults(defineProps<Props>(), { tone: 'dark', size: 22 });
</script>
